import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";
import {
  TYPE_LABELS,
  formatDate,
  formatNumber,
  FileCell,
  DotsMenu,
} from "./tableUtils";

interface ColumnDef {
  label: string;
  width?: number;
}

const COLUMNS: ColumnDef[] = [
  { label: "Transakcja", width: 80 },
  { label: "Data", width: 80 },
  { label: "Ilość sztuk", width: 100 },
  { label: "Umowa", width: 80 },
  { label: "Kurs", width: 120 },
];

interface CurrenciesTableProps {
  transactions: InvestmentTransactionType[];
  isOwn?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const CurrenciesTable = ({
  transactions,
  isOwn = false,
  onEditTx,
}: CurrenciesTableProps) => {
  return (
    <table className="itm-table">
      <colgroup>
        {COLUMNS.map((col, i) => (
          <col key={i} style={col.width ? { width: col.width } : undefined} />
        ))}
      </colgroup>
      <thead>
        <tr>
          {COLUMNS.map((col, i) => (
            <th key={i}>{col.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {transactions.map((tx) => (
          <tr key={tx.uuid}>
            <td>{TYPE_LABELS[tx.type] ?? tx.type}</td>
            <td>{formatDate(tx.completedAt ?? tx.createdAt)}</td>
            <td>
              {tx.type === "buy" ? "+" : "-"}
              {tx.quantity ?? "—"} {tx?.currency?.currency}
            </td>
            <td>
              <FileCell tx={tx} />
            </td>
            <td>{formatNumber(tx.unitPrice)}</td>
            <td>
              <DotsMenu
                tx={tx}
                onEdit={
                  isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CurrenciesTable;
